export default __webpack_public_path__ + "static/media/downLine.d4b0dce1.svg";